import { NotificationRegistry } from '@neos/core'
import AdditionalPropertyDataUpdatedNotificationEventArgs from '@src/dataObjects/AdditionalPropertyDataUpdatedNotificationEventArgs'
import AdditionalPropertyMetadataUpdatedNotificationEventArgs from '@src/dataObjects/AdditionalPropertyMetadataUpdatedNotificationEventArgs'
import ClustersByUserDiagnosticStatus from '@src/dataObjects/ClustersByUserDiagnosticStatus'
import DatabaseMigrationResult from '@src/dataObjects/DatabaseMigrationResult'
import NeosDataImportBackgroundExecutionStateChangedEventArgs from '@src/dataObjects/NeosDataImportBackgroundExecutionStateChangedEventArgs'
import NeosDataImportTemplateUpdatedEventArgs from '@src/dataObjects/NeosDataImportTemplateUpdatedEventArgs'
import NeosDeploymentNeosServiceInfo from '@src/dataObjects/NeosDeploymentNeosServiceInfo'
import NeosUserNotificationGroup from '@src/dataObjects/NeosUserNotificationGroup'

/**
 * Represents Notifications.
 */
export default class Notifications extends NotificationRegistry {
  /**
   * Gets or sets AdditionalPropertyDataUpdated.
   */
  additionalPropertyDataUpdated = this.create<AdditionalPropertyDataUpdatedNotificationEventArgs, void>('AdditionalPropertyDataUpdated')

  /**
   * Gets or sets AdditionalPropertyMetadataUpdated.
   */
  additionalPropertyMetadataUpdated = this.create<AdditionalPropertyMetadataUpdatedNotificationEventArgs, void>('AdditionalPropertyMetadataUpdated')

  /**
   * Gets or sets ClustersByUserDiagnosticStatus.
   */
  clustersByUserDiagnosticStatus = this.create<ClustersByUserDiagnosticStatus, void>('ClustersByUserDiagnosticStatus')

  /**
   * Gets or sets MigrationResult.
   */
  migrationResult = this.create<DatabaseMigrationResult, void>('MigrationResult')

  /**
   * Gets or sets NeosDataImportBackgroundExecutionStateChanged.
   */
  neosDataImportBackgroundExecutionStateChanged = this.create<NeosDataImportBackgroundExecutionStateChangedEventArgs, void>('NeosDataImportBackgroundExecutionStateChanged')

  /**
   * Gets or sets NeosDataImportTemplateUpdated.
   */
  neosDataImportTemplateUpdated = this.create<NeosDataImportTemplateUpdatedEventArgs, void>('NeosDataImportTemplateUpdated')

  /**
   * Gets or sets NeosServiceInfoReceived.
   */
  neosServiceInfoReceived = this.create<NeosDeploymentNeosServiceInfo, void>('NeosServiceInfoReceived')

  /**
   * Gets or sets UserNotification.
   */
  userNotification = this.create<NeosUserNotificationGroup, void>('UserNotification')
}